// SLIDER LOGIC
document.addEventListener('DOMContentLoaded', () => {
  initCardSliders();
});

function initCardSliders() {
  document.querySelectorAll('.card-image-slider').forEach(slider => {
    // Prevent re-initialization
    if (slider.dataset.initialized) return;
    slider.dataset.initialized = 'true';

    const container = slider.querySelector('.slider-container');
    const dots = slider.querySelectorAll('.dot');
    const arrows = slider.querySelectorAll('.slider-arrow');

    if (container && dots.length > 0) {
      container.addEventListener('scroll', () => {
        const index = Math.round(container.scrollLeft / container.clientWidth);
        dots.forEach((dot, i) => {
          dot.classList.toggle('active', i === index);
        });
      });
    }

    if (container && arrows.length > 0) {
      arrows.forEach(arrow => {
        arrow.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const direction = arrow.classList.contains('next') ? 1 : -1;
          container.scrollBy({ left: direction * container.clientWidth, behavior: 'smooth' });
        });
      });
    }
  });
}

// Re-init on DOM mutations (for infinite scroll, ajax loading)
const observer = new MutationObserver((mutations) => {
  let shouldInit = false;
  mutations.forEach((mutation) => {
    if (mutation.addedNodes.length) shouldInit = true;
  });
  if (shouldInit) initCardSliders();
});
observer.observe(document.body, { childList: true, subtree: true });

// QUICK ADD MODAL LOGIC (Exact Bluorng UI)
let modal;
let closeBtn;

document.addEventListener('DOMContentLoaded', () => {
  modal = document.querySelector('.bluorng-quick-add-modal');
  closeBtn = document.querySelector('.close-modal');

  if (closeBtn && modal) {
    closeBtn.onclick = () => modal.classList.remove('active');
  }

  const sizeModal = document.querySelector('.bluorng-size-chart-modal');
  const closeSizeBtn = document.querySelector('.close-size-chart');
  
  if (closeSizeBtn && sizeModal) {
    closeSizeBtn.onclick = () => sizeModal.classList.remove('active');
  }

  window.onclick = (e) => { 
    if (modal && e.target == modal) modal.classList.remove('active'); 
    if (sizeModal && e.target == sizeModal) sizeModal.classList.remove('active'); 
  }
});

window.openQuickAdd = async function(handle) {
  if (!modal) modal = document.querySelector('.bluorng-quick-add-modal');
  modal.dataset.cachedHandle = handle;
  
  try {
    const response = await fetch(`/products/${handle}.js`);
    const product = await response.json();

    document.getElementById('ModalTitle').textContent = product.title;
    document.getElementById('ModalPrice').textContent = 'RS. ' + (product.variants[0].price / 100);
    
    // Size pills in a grid
    const variantHtml = product.variants.map((v, idx) => `
      <div class="v-pill-premium ${v.available ? '' : 'disabled'} ${idx === 0 ? 'active' : ''}" 
           onclick="selectModalVariant(${v.id}, this)">
        ${v.title}
      </div>
    `).join('');
    
    document.getElementById('ModalVariants').innerHTML = variantHtml;
    modal.classList.add('active');
    window.selectedModalVariantId = product.variants[0].id;
  } catch (error) {
    console.error("Failed to load product data", error);
  }
};

window.selectModalVariant = function(id, el) {
  if (el.classList.contains('disabled')) return;
  document.querySelectorAll('.v-pill-premium').forEach(p => p.classList.remove('active'));
  el.classList.add('active');
  window.selectedModalVariantId = id;
};

document.addEventListener('click', async function(e) {
  if (e.target.id === 'ModalAddToCart') {
    const btn = e.target;
    const originalText = btn.textContent;
    btn.textContent = 'ADDING...';
    btn.disabled = true;

    try {
      const cartItemsComponents = document.querySelectorAll('cart-items-component');
      const cartItemComponentsSectionIds = [];
      for (const item of cartItemsComponents) {
        if (item.dataset && item.dataset.sectionId) {
          cartItemComponentsSectionIds.push(item.dataset.sectionId);
        }
      }
      
      const payload = {
        items: [{ id: window.selectedModalVariantId, quantity: 1 }],
        sections: cartItemComponentsSectionIds.join(',')
      };

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      if (response.ok) {
        const json = await response.json();
        btn.textContent = 'ADDED!';
        
        if (typeof showGlobalToast === 'function') showGlobalToast();
        
        // Update DOM for Cart Drawer and Cart Icon
        if (json.sections) {
           // We loop through the requested sections and update their HTML dynamically
           for (const sectionId of cartItemComponentsSectionIds) {
             const sectionHtml = json.sections[sectionId];
             if (sectionHtml) {
               const targetComponent = document.querySelector(`cart-items-component[data-section-id="${sectionId}"]`);
               if (targetComponent) {
                 const parser = new DOMParser();
                 const doc = parser.parseFromString(sectionHtml, 'text/html');
                 const newComponent = doc.querySelector(`cart-items-component[data-section-id="${sectionId}"]`);
                 if (newComponent) {
                   targetComponent.innerHTML = newComponent.innerHTML;
                 }
               }
             }
           }
           
           const cartDrawer = document.querySelector('theme-drawer#cart-drawer');
           if (cartDrawer && typeof cartDrawer.open === 'function') {
             cartDrawer.open();
           }
        }

        setTimeout(() => {
          if (modal) modal.classList.remove('active');
          btn.textContent = originalText;
          btn.disabled = false;
        }, 300);
      } else {
        const err = await response.json();
        console.error('Failed to add to cart:', err);
        btn.textContent = originalText;
        btn.disabled = false;
      }
    } catch (error) {
       console.error('Failed to add to cart', error);
       btn.textContent = originalText;
       btn.disabled = false;
    }
  }

  if (e.target.id === 'ModalBuyNow') {
     window.location.href = `/cart/${window.selectedModalVariantId}:1`;
  }
});

// SIZE CHART LOGIC
window.openSizeChart = async function() {
  const sizeModal = document.querySelector('.bluorng-size-chart-modal');
  if (sizeModal) sizeModal.classList.add('active');
};

function showGlobalToast() {
  const toast = document.getElementById(`GlobalCartToast`);
  if (toast) {
    toast.classList.add('visible');
    setTimeout(() => toast.classList.remove('visible'), 3000);
  }
}
